<template>
  <div>
    <dashboard-v2 v-if="displayNewDasboard" />
    <dashboard-v1 v-if="displayNewDasboard === false" />
  </div>
</template>

<script>
import DashboardV1 from './DashboardV1.vue';
import DashboardV2 from './DashboardV2.vue';
import { getByParameterName } from '@/services/common/sysparameter.api';

export default {
  name: 'Dashboard',
  components: {
    DashboardV1,
    DashboardV2,
  },
  data() {
    return {
      displayNewDasboard: null,
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  async mounted() {
    const { data } = await getByParameterName('DisplayNewDashboardRemPro');
    this.displayNewDasboard = data.value?.toLowerCase() == 'true' ?? false;
  },
};
</script>
